<section
  class="block-categories"
  aria-label="Categorías"
  (mouseenter)="onWrapperMouseEnter()"
  (mouseleave)="onWrapperMouseLeave()"
  (focusin)="onWrapperFocusIn()"
  (focusout)="onWrapperFocusOut($event)"
  (touchstart)="onWrapperTouchStart()"
  (touchend)="onWrapperTouchEnd()"
>
  <div class="block-categories__track" #track [attr.aria-busy]="loading()">
    @if (loading()) {
      @for (item of skeletonItems; track item) {
      <div class="block-categories__card block-categories__card--skeleton" aria-hidden="true">
        <div class="block-categories__card-content block-categories__skeleton-content">
          <span class="block-categories__skeleton-line block-categories__skeleton-line--title"></span>
          <span class="block-categories__skeleton-line block-categories__skeleton-line--cta"></span>
        </div>
      </div>
      }
    } @else {
    @for (category of categories(); track category.id) {
    <a class="block-categories__card" [routerLink]="category.slug">
      <img
        class="block-categories__card-image"
        [src]="category.image"
        [alt]="category.name"
        loading="lazy"
      />
      <div class="block-categories__card-overlay"></div>
      <div class="block-categories__card-content">
        <h3 class="block-categories__card-name">{{ category.name }}</h3>
        <span class="block-categories__card-cta">Explorar ahora</span>
      </div>
    </a>
    }
    }
  </div>

  @if (!loading() && categories().length > 1) {
  <button
    class="block-categories__arrow block-categories__arrow--prev"
    type="button"
    aria-label="Anterior"
    (click)="scrollPrev()"
  >
    <app-icon [icon]="chevronLeft" [size]="20" />
  </button>

  <button
    class="block-categories__arrow block-categories__arrow--next"
    type="button"
    aria-label="Siguiente"
    (click)="scrollNext()"
  >
    <app-icon [icon]="chevronRight" [size]="20" />
  </button>
  }
</section>
